export default __webpack_public_path__ + "static/media/screenshot2_sm.9c1cca5b.jpg";